module.exports = __webpack_public_path__ + "images/loading_background.png";